import { NotificationListFilters } from './notifications.model'

export const serializeNotificationListFilters = ({ unread, types }: NotificationListFilters) => ({
  types: types?.join(','),
  unread,
})
